import { Injectable } from '@angular/core';
import { BehaviorSubject }    from 'rxjs/BehaviorSubject';

@Injectable()

export class HorizonCalcComponentService {
  
  constructor() {
    console.log("construct BMCS");
  }
  // Observable string sources
  private showLiabilities = new BehaviorSubject<boolean>(false);
  // Observable string streams
  ShowLiabilities$ = this.showLiabilities.asObservable();
  
  public resetService() {
    console.log("HorizonCalcComponent.service : resetService");
  }

  public SwitchView(isLiability:boolean) {
    console.log("GCS StartGame " + isLiability);
    this.showLiabilities.next(isLiability);
  }
}


// WEBPACK FOOTER //
// ./src/app/horizoncalc/horizoncalcComponent.service.ts